import React from "react";
import { AddressSetting } from "../../../../application/domain/acl";
import { BaseModal } from "../../../atoms/base-modal";

interface OrganizationDeleteAclModalProps {
  target: AddressSetting;
  isActive: boolean;
  onDelete: () => void;
  onModal: () => void;
}

export const OrganizationDeleteAclModal: React.FunctionComponent<
  OrganizationDeleteAclModalProps
> = ({ isActive, target, onDelete, onModal }) => {
  return (
    <BaseModal
      isActive={isActive}
      title={"IPアドレス設定の削除"}
      onClose={onModal}
    >
      <section className="modal-card-body">
        <div className="field">
          <p>下記のIPアドレスの設定を削除します。よろしいでしょうか。</p>
        </div>
        <div className="field">
          <label className="label">IPアドレス</label>
          <div className="control">
            <p>{target.ipAddress}</p>
          </div>
        </div>
        <div className="field">
          <label className="label">コメント</label>
          <div className="control">
            <p>{target.remarks}</p>
          </div>
        </div>
      </section>
      <footer className="modal-card-foot">
        <button className="button is-failure is-fullwidth" onClick={onModal}>
          キャンセル
        </button>
        <button className={"button is-info is-fullwidth"} onClick={onDelete}>
          {"削除する"}
        </button>
      </footer>
    </BaseModal>
  );
};
